(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("layer-stress-test", [], factory);
	else if(typeof exports === 'object')
		exports["layer-stress-test"] = factory();
	else
		root["layer-stress-test"] = factory();
})(self, function() {
return 